/**
 * <AdaptedRequestBanner> — « Adapté à votre demande » : la phrase de la famille, en haut du
 * programme qu'elle a recomposé (molecule).
 *
 * Elle cite la phrase et offre les deux suites : « Modifier »
 * (la feuille se rouvre sur la phrase) et « Revenir au programme proposé ». Sans geste — le stage
 * a commencé —, elle ne garde que la phrase : ce qui a été demandé reste lisible.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { TextButton } from "../../atoms/Buttons/TextButton"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Icon } from "../../atoms/icons/Icon"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../Card"

export type AdaptedRequestBannerProps = {
    instructions: string
    onEdit?: () => void
    onReset?: () => void
    /** Une recomposition est en cours : les gestes attendent. */
    busy?: boolean
    testID?: string
}

export function AdaptedRequestBanner(props: AdaptedRequestBannerProps) {
    const { instructions, onEdit, onReset, busy = false, testID } = props

    return (
        <Card background="primary-soft" elevation="none" testID={testID}>
            <Stack gap="2">
                <Row gap="2" align="center">
                    <Icon name="check-circle" size={16} color="primary" />
                    <Text size="text-md" weight="extrabold" color="primary">
                        Adapté à votre demande
                    </Text>
                </Row>
                <Text size="text-md" style={styles.quote}>
                    « {instructions} »
                </Text>
                {(onEdit != null || onReset != null) && (
                    <Row gap="4" style={styles.actions}>
                        {onEdit != null && <TextButton label="Modifier" size="sm" onPress={onEdit} disabled={busy} />}
                        {onReset != null && (
                            <TextButton
                                label="Revenir au programme proposé"
                                size="sm"
                                onPress={onReset}
                                disabled={busy}
                            />
                        )}
                    </Row>
                )}
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    quote: {
        fontStyle: "italic",
    },
    actions: {
        flexWrap: "wrap",
    },
}))
